import apiClient from '@/api/client';

export const ProvisioningService = {
    async getStatus(id: string): Promise<GetPartnerCreationStatusResponse> {
        const response = await apiClient.get<GetPartnerCreationStatusResponse>(`/partners/${id}/creation-status`);
        const result = response.data

        if (response.status != 200) {
            throw new Error('Failed to get partner creation status.');
        }

        return result;
    },

    async retryCreation(id: string) {
      const response = await apiClient.post(`/partners/${id}/retry-creation`);
      const result = response.data

      if (response.status != 200) {
          throw new Error('Failed to retry partner creation process.');
      }

      return result;
    },

    async cancelCreation(id: string) {
      const response = await apiClient.post<GetPartnerCreationStatusResponse>(`/partners/${id}/cancel-creation`);
      const result = response.data

      if (response.status != 200) {
          throw new Error('Failed to cancel partner creation process.');
      }

      return result;
    },

    async deleteCreationRequest(id: string) {
      const response = await apiClient.delete(`/partners/${id}/creation-request`);
      const result = response.data

      if (response.status != 204) {
          throw new Error('Failed to delete partner creation request.');
      }

      return result;
    },

    async create(name: string): Promise<CreatePartnerResponse> {
        const response = await apiClient.post<CreatePartnerResponse>('/partners', 
        {
            name: name
        });
        const result = response.data

        if (response.status != 200) {
            throw new Error('Failed to create partner.');
        }

        return result;
      }
}

export interface GetPartnerCreationStatusResponse {
    requestId: string
    partnerName: string
    partnerId: number | null
    keycloakGroupId: string | null
    databaseName: string | null
    status: 'Pending' | 'InProgress' | 'Completed' | 'Failed'
    currentStep: 'CreatingKeycloakGroup' | 'ProvisioningDatabase' | 'CreatingPartnerRecord' | 'Completed'
    requestedAt: string
    keycloakGroupCreatedAt: string | null
    databaseProvisioningStartedAt: string | null
    databaseProvisionedAt: string | null
    partnerRecordCreatedAt: string | null
    completedAt: string | null
    errorMessage: string | null
    progress: PartnerCreationProgress
    canCancel: boolean
    canRetry: boolean
  }

export interface CreatePartnerResponse {
  requestId: string
  partnerName: string
  partnerId: number | null
  keycloakGroupId: string | null
  databaseName: string | null
  status: 'Pending' | 'InProgress' | 'Completed' | 'Failed'
  currentStep: 'CreatingKeycloakGroup' | 'ProvisioningDatabase' | 'CreatingPartnerRecord' | 'Completed'
  requestedAt: string
  keycloakGroupCreatedAt: string | null
  databaseProvisioningStartedAt: string | null
  databaseProvisionedAt: string | null
  partnerRecordCreatedAt: string | null
  completedAt: string | null
  errorMessage: string | null
  progress: PartnerCreationProgress
  canCancel: boolean
  canRetry: boolean
}

export interface PartnerCreationProgress {
  percentComplete: number
  statusMessage: string
  steps: PartnerCreationStep[]
  estimatedTimeRemaining: string | null
}

export interface PartnerCreationStep {
    name: string
    status: 'Pending' | 'InProgress' | 'Completed'
    completedAt: string | null
    details: string | null
  }
  